import './Indicator.css'

export default function Indicator({ state = 'off' }) {
    return (
        <div className={`indicator ${state === 'on' ?  "indicator-on" : state === 'on_yellow' ? "indicator-on-yellow" : "indicator-off"}`}></div>
    )
}